import React from 'react';
const WaterFall = ({ column = 2, title, padding = 6, dataSource = [], children }) => {
    const margin = padding * (column - 1) / column;
    const width = `calc(${(100 / column).toFixed(3)}% - ${margin}px)`;
    const basisStyle = { flexBasis: width, maxWidth: width, overflow: 'hidden' };
    const rows = Math.ceil(dataSource.length / column);
    return <div className='waterfall'>
    {title ? <div className='waterfall-title'>{title}</div> : null}
    <div className='waterfall-cols'>
      {[...Array(column).keys()].map(col => {
        return <div key={col} style={basisStyle}>
            {[...Array(rows).keys()].map(row => {
            const index = row * column + col;
            const item = dataSource[index];
            return item ? children(item, index) : null;
        })}
          </div>;
    })}
    </div>
  </div>;
};
export default WaterFall;



// WEBPACK FOOTER //
// ./components/water-fall/index.tsx